import React from 'react';
type Coach = {
  title: string;
  body: string;
  tokens: {
    cls: string;
    letter?: string;
  }[];
};
const coaches: Coach[] = [{
  title: 'The volun-told parent',
  body: 'You said yes because nobody else would. Every session tells you where the cones go, what to say and how long each station runs, and Bonus 02 explains the game in plain English.',
  tokens: [{
    cls: 'bg-willow text-willow-ink',
    letter: 'C'
  }]
}, {
  title: 'The coach with a big squad',
  body: 'Twenty kids, one net and a couple of parent helpers. Three stations and one rotation signal keep everyone batting, bowling or fielding, within your national body’s ratios.',
  tokens: [{
    cls: 'bg-willow text-willow-ink',
    letter: 'C'
  }, {
    cls: 'bg-[#8A938C] text-white',
    letter: 'H'
  }, {
    cls: 'bg-[#8A938C] text-white',
    letter: 'H'
  }]
}, {
  title: 'The coach of a mixed squad',
  body: 'Beginners next to kids who’ve played for years. The soft-ball and hard-ball tracks run inside the same session, so one plan fits the whole group.',
  tokens: [{
    cls: 'bg-[#2C5FB8]'
  }, {
    cls: 'bg-cherry'
  }, {
    cls: 'bg-[#2C5FB8]'
  }, {
    cls: 'bg-cherry'
  }]
}];

/** "Who it's for": shown in place of reviews until real ones come in. */
export function Audience() {
  return <section aria-labelledby="audience-heading" className="w-full bg-field text-cream" data-id="element-38" data-mp="1kdsms8pg0b45">
      <div className="mx-auto max-w-6xl px-5 py-16 sm:py-20" data-id="element-39" data-mp="1pcm1u5kdoa6f">
        <div className="text-center" data-id="element-40" data-mp="1p9zti3pnxqn5">
          <p className="text-[11px] font-semibold uppercase tracking-[1.6px] text-willow" data-id="element-41" data-mp="1ua5dcxpoy8uo">Who it&apos;s for</p>
          <h2 id="audience-heading" className="mt-3 font-display text-3xl text-cream sm:text-5xl" data-id="element-42" data-mp="1z2osw07xve24">
            Built for the coach who got handed the squad
          </h2>
          <p className="mx-auto mt-4 max-w-2xl text-sm text-cream/70 sm:text-base" data-id="element-43" data-mp="282lji7dw2mzt">
            Volunteer, parent and club coaches running junior cricket, with more
            kids than nets and less time than they&apos;d like.
          </p>
        </div>

        <div className="mt-9 grid gap-4 md:grid-cols-3" data-id="element-44" data-mp="czf57dl1nec6">
          {coaches.map(coach => <article key={coach.title} className="flex flex-col rounded-2xl border border-field-line bg-field-card p-5 shadow-card sm:p-6" data-id="element-45" data-mp="8zet3zlf3f8a">
              <ul className="flex -space-x-1.5" aria-hidden="true" data-id="element-46" data-mp="hyiamz4xrmko">
                {coach.tokens.map((t, i) => <li key={i} data-id="element-47" data-mp="wmd78qm2eb31" data-mpi={i}>
                    <span className={`flex h-9 w-9 items-center justify-center rounded-full border-2 border-field-card font-display text-sm font-extrabold shadow-[inset_0_-3px_6px_rgba(0,0,0,0.3)] ${t.cls}`} data-id="element-48" data-mp="wlla3bctk5an">
                      {t.letter}
                    </span>
                  </li>)}
              </ul>
              <h3 className="mt-4 font-display text-xl font-extrabold leading-tight text-cream" data-id="element-49" data-mp="37eeehd42cuw5">{coach.title}</h3>
              <p className="mt-2 text-sm leading-relaxed text-cream/75" data-id="element-50" data-mp="32hegzqla50gn">{coach.body}</p>
            </article>)}
        </div>
      </div>
    </section>;
}